var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttendance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f5a161",
    opacity: 1,
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z",
    opacity: 1,
    fill: "#ffe17e"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    fill: "#ffe17e"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M676.202+824.093C676.202+750.358+735.976+690.584+809.711+690.584C883.446+690.584+943.22+750.358+943.22+824.093C943.22+897.829+883.446+957.603+809.711+957.603C735.976+957.603+676.202+897.829+676.202+824.093Z",
    fill: "#18ea39"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#ffffff",
    d: "M706.597+823.588C706.597+766.567+752.822+720.342+809.844+720.342C866.866+720.342+913.091+766.567+913.091+823.588C913.091+880.61+866.866+926.836+809.844+926.836C752.822+926.836+706.597+880.61+706.597+823.588Z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#18ea39",
    d: "M792.154+826.708C791.692+827.632+791.229+828.557+790.767+829.481"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "none",
    d: "M757.105+820.113L799.26+873.928L857.56+782.443",
    strokeLinecap: "round",
    strokeWidth: 32,
    stroke: "#18ea39",
    strokeLinejoin: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/Attendance.894204259d876ca3472009c9e3494072.svg";
export { ForwardRef as ReactComponent };